import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4.755 10.5L7 8L4.755 5.5M4.755 18.5L7 16L4.755 13.5M10 8H20M10 16H20" />
	</SVG>
);
